import { createSelector } from '@reduxjs/toolkit';

import { MIN_PLAY_RANGE_DURATION } from 'constants/trimming';

import { selectPlayerTime } from './videoPlayer';

const selectTrimming = state => state.trimming;

export const selectSendingNewTrim = createSelector(
  selectTrimming,
  trimming => trimming.sendingNewTrim
);

export const selectTrimRanges = createSelector(
  selectTrimming,
  trimming => trimming.trim_ranges
);

export const selectSelectedPlayRange = createSelector(
  selectTrimming,
  trimming => trimming.selectedPlayRange
);

export const selectPlayRanges = createSelector(
  selectTrimming,
  trimming => trimming.playRanges
);

export const selectTrimNewChanges = createSelector(
  selectTrimming,
  trimming => trimming.new_changes
);

export const selectCanUndoPlayRange = createSelector(
  selectTrimming,
  ({ playRangeUndoPointer }) => {
    return playRangeUndoPointer > 0;
  }
);

export const selectCanRedoPlayRange = createSelector(
  selectTrimming,
  ({ playRangeUndoStack, playRangeUndoPointer }) => {
    return playRangeUndoPointer < playRangeUndoStack.length - 1;
  }
);

export const selectSelectedPlayRangeHandle = createSelector(
  selectTrimming,
  ({ selectedPlayRangeHandle }) => selectedPlayRangeHandle
);

export const selectHasSelectedPlayRange = createSelector(
  selectTrimming,
  trimming =>
    trimming.selectedPlayRange !== null &&
    trimming.selectedPlayRange !== undefined
);

export const selectCurrentTimeInSelectedPlayRangeBounds = createSelector(
  state => ({
    currentTime: selectPlayerTime(state),
    playRanges: selectPlayRanges(state),
    selectedPlayRange: selectSelectedPlayRange(state),
  }),
  ({ currentTime, playRanges, selectedPlayRange }) =>
    Boolean(
      currentTime - playRanges[selectedPlayRange]?.from >=
        MIN_PLAY_RANGE_DURATION &&
        playRanges[selectedPlayRange]?.to - currentTime >=
          MIN_PLAY_RANGE_DURATION
    )
);

export const selectCanSplitPlayRange = createSelector(
  state => ({
    playRanges: selectPlayRanges(state),
    hasSelectedPlayRange: selectHasSelectedPlayRange(state),
    currentTimeInSelectedPlayRangeBounds: selectCurrentTimeInSelectedPlayRangeBounds(
      state
    ),
  }),
  ({
    playRanges,
    hasSelectedPlayRange,
    currentTimeInSelectedPlayRangeBounds,
  }) =>
    Boolean(
      playRanges?.length > 0 &&
        hasSelectedPlayRange &&
        currentTimeInSelectedPlayRangeBounds
    )
);

export const selectCanDeletePlayRange = createSelector(
  state => ({
    playRanges: selectPlayRanges(state),
    hasSelectedPlayRange: selectHasSelectedPlayRange(state),
  }),
  ({ playRanges, hasSelectedPlayRange }) =>
    Boolean(hasSelectedPlayRange && playRanges?.length > 1)
);
